import React from 'react';
import { SemanticSegment, SemanticLoader,SemanticSegmentDiv } from './styles';

const Loader =  props => {

  if(props.div) {
    return (
      <SemanticSegmentDiv style={{border: "none"}}>
        <SemanticLoader active>
          {!props.noText && <p>{props.text}</p>}
        </SemanticLoader>
      </SemanticSegmentDiv>
    );

  }
  return (
    <SemanticSegment style={{border: "none"}}>
      <SemanticLoader active>
        {!props.noText && <p>{props.text}</p>}
      </SemanticLoader>
    </SemanticSegment>
  );
};

export default Loader;
